import React from 'react';
import Icon from '../../../components/AppIcon';
import { getRecentEvents, EVENT_TYPES } from '../../../services/eventAnalyticsService';

const EVENT_CONFIG = {
  [EVENT_TYPES?.FORM_VIEW]: { icon: 'Eye', label: 'Form Viewed', color: '#107570', bg: 'bg-primary/10' },
  [EVENT_TYPES?.FORM_START]: { icon: 'PlayCircle', label: 'Form Started', color: '#0d9488', bg: 'bg-teal-500/10' },
  [EVENT_TYPES?.FORM_SUBMIT]: { icon: 'CheckCircle2', label: 'Form Submitted', color: '#22c55e', bg: 'bg-success/10' },
  [EVENT_TYPES?.FORM_ABANDON]: { icon: 'XCircle', label: 'Form Abandoned', color: '#f59e0b', bg: 'bg-warning/10' },
  [EVENT_TYPES?.PAYMENT_INITIATED]: { icon: 'CreditCard', label: 'Payment Initiated', color: '#6366f1', bg: 'bg-indigo-500/10' },
  [EVENT_TYPES?.PAYMENT_COMPLETE]: { icon: 'BadgeCheck', label: 'Payment Complete', color: '#22c55e', bg: 'bg-success/10' },
  [EVENT_TYPES?.PAYMENT_FAILED]: { icon: 'AlertCircle', label: 'Payment Failed', color: '#ef4444', bg: 'bg-error/10' },
};

const LiveEventFeed = ({ events }) => {
  const items = events || getRecentEvents();

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Live Event Feed</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Real-time platform activity stream</p>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-success animate-pulse" />
          <span className="text-xs text-success font-medium">Live</span>
        </div>
      </div>
      <div className="space-y-3 max-h-72 overflow-y-auto scrollbar-custom pr-1">
        {items?.map((event) => {
          const cfg = EVENT_CONFIG?.[event?.type] || EVENT_CONFIG?.[EVENT_TYPES?.FORM_VIEW];
          return (
            <div key={event?.id} className="flex items-start gap-3 p-2.5 rounded-lg hover:bg-muted/40 transition-colors">
              <div className={`w-8 h-8 rounded-lg ${cfg?.bg} flex items-center justify-center flex-shrink-0 mt-0.5`}>
                <Icon name={cfg?.icon} size={14} color={cfg?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-xs font-semibold text-foreground truncate">{cfg?.label}</span>
                  <span className="text-[10px] text-muted-foreground flex-shrink-0">{event?.time}</span>
                </div>
                <p className="text-xs text-muted-foreground truncate">{event?.form}</p>
                <p className="text-[10px] text-muted-foreground/70 mt-0.5">{event?.meta}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LiveEventFeed;
